import { CtaButton } from '@zappyrent/hundop';
import { motion } from 'framer-motion';
import { rem, rgba } from 'polished';
import styled, { css } from 'styled-components';

export const StyledProfile = styled(motion.section)`
  position: fixed;
  right: 0;
  top: 0;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.cross.ultralightGray};
  ${({ theme }) => css`
    box-shadow: 0 0 ${rem('8px')} ${rgba(theme.colors.cross.silverFox, 0.5)};
  `};
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  width: min(100%, ${rem('480px')});
`;

export const StyledProfileTopBar = styled.div`
  width: 100%;
  height: ${rem('72px')};
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: ${rem('24px')};
  border-bottom: 1px solid ${({ theme }) => theme.colors.cross.silverFox};
  flex: 0 0 auto;
`;

export const StyledProfileData = styled.div`
  width: 100%;
  position: relative;
  padding: ${rem('24px')};
  padding-top: ${rem('40px')};
  flex: 1 1 auto;
  overflow: auto;
`;

export const StyledProfileDataFields = styled.div`
  margin-top: ${rem('32px')};
  display: flex;
  flex-direction: column;
  gap: ${rem('8px')};
`;

export const StyledProfileBottomBar = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${rem('8px')};
  padding: ${rem('24px')};
  border-top: 1px solid ${({ theme }) => theme.colors.cross.silverFox};
  flex: 0 0 auto;
`;

export const StyledConfirmButton = styled(CtaButton)`
  text-transform: uppercase;
  width: 100%;
`;

export const StyledCloseButton = styled.button`
  border: none;
  outline: none;
  cursor: pointer;
  background: none;
  padding: ${'12px'};
  margin: ${'-12px'};

  position: relative;

  svg {
    width: ${rem('12px')};
    height: ${rem('12px')};

    path {
      fill: ${({ theme }) => theme.colors.cross.black};
    }
  }
`;

export const StyledEditButton = styled.button`
  position: absolute;
  top: ${rem('44px')};
  right: ${rem('24px')};
  z-index: 100;
  display: flex;

  margin: 0;
  padding: 0;
  color: ${({ disabled, theme }) =>
    disabled ? theme.colors.cross.silverFox : theme.colors.landlord.main};
  font-size: ${rem('16px')};
  font-weight: 700;
  text-decoration: underline;
  background-color: transparent;
  border: none;
  cursor: ${({ disabled }) => (disabled ? `default` : `pointer`)};
  appearance: none;
`;

export const StyledLogoutButton = styled(CtaButton)`
  text-transform: uppercase;
  width: 100%;
`;
